import React from "react";

const PriceDetails = ({ data = [] }) => {
  return (
    <div className="price-details-wrapper">
      <h2 className="f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mb-3">
        Price Details
      </h2>

      <div className="table-responsive">
        <table className="price-table">
          <tbody>
            {data.map((item, ind) => {
              const total =
                Number(item?.room_price || 0) +
                Number(item?.ex_person_charges || 0);

              return (
                <tr key={ind}>
                  <td className="room-title">Room {ind + 1}</td>

                  <td>
                    <span className="label">Room Price:</span>{" "}
                    {item?.room_price}
                  </td>

                  <td>
                    <span className="label">Ex-Person Price:</span>{" "}
                    {item?.ex_person_price}
                  </td>

                  <td>
                    <span className="label">Ex-Person Count:</span>{" "}
                    {item?.ex_person_count}
                  </td>

                  <td>
                    <span className="label">Ex-Person Charges:</span>{" "}
                    {item?.ex_person_price} × {item?.ex_person_count} ={" "}
                    {item?.ex_person_charges}
                  </td>

                  <td className="total-text">Total: {item?.total || total}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <style jsx>{`
        .price-details-wrapper {
          width: 100%;
        }

        .table-responsive {
          overflow-x: auto;
          margin-top: 16px;
          overflow-x: scroll;
          overflow-y: scroll;
          max-height: auto;
          min-height: auto;
          background-color: #fff;
          border: 1px solid #e6eff5;
        }

        .price-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0 12px;
        }

        .price-table tr {
          // background: #f7f7f7;
          border-radius: 10px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .price-table td {
          padding: 14px 16px;
          font-size: 14px;
          white-space: nowrap;
          color: #333;
        }

        .room-title {
          font-weight: 600;
          min-width: 90px;
        }

        .label {
          font-weight: 500;
          color: #666;
        }

        .total-text {
          color: #a855f7;
          font-weight: 700;
        }

        @media (max-width: 768px) {
          .price-table td {
            padding: 10px 12px;
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default PriceDetails;
